const ELLIPSIS = '…'

/**
 * Shortens `value` to at most `maxLength` characters by cutting the MIDDLE out, so both the
 * start and the end survive — for identifiers and names whose distinguishing part is often the
 * suffix (`auto-tests-tc202-…-gifpfh0r`). Returns the value untouched when it already fits.
 */
export const truncateMiddle = (value: string, maxLength: number): string => {
  if (maxLength < 3 || value.length <= maxLength) {
    return value
  }

  const visible = maxLength - ELLIPSIS.length
  const headLength = Math.ceil(visible / 2)
  const tailLength = visible - headLength

  return `${value.slice(0, headLength)}${ELLIPSIS}${value.slice(value.length - tailLength)}`
}
